import { createInertiaApp } from "@inertiajs/vue3";
import * as Sentry from "@sentry/vue";
import { setDefaultOptions } from "date-fns";
import { da } from "date-fns/locale";
import { createApp, type DefineComponent, h } from "vue";

import DefaultLayout from "@/layouts/DefaultLayout.vue";

setDefaultOptions({ locale: da });

const pages = import.meta.glob<DefineComponent>("@/pages/**/*.vue", {
  eager: true,
});

void createInertiaApp({
  title: (title) => {
    if (title) {
      return `${title} — ${import.meta.env.PUBLIC_APP_NAME}`;
    }

    return import.meta.env.PUBLIC_APP_NAME;
  },
  resolve: (name) => {
    const component = pages[`/pages/${name}.vue`];

    if (!component) {
      throw new Error(
        `Unknown page '${name}'. Is it located under @/pages with a .vue extension?`,
      );
    }

    component.default.layout ??= DefaultLayout;

    return component;
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  setup({ el, App, props, plugin }) {
    // eslint-disable-next-line vue/component-api-style
    const app = createApp({ render: () => h(App, props) });

    if (import.meta.env.PUBLIC_SENTRY_DSN) {
      Sentry.init({
        app,
        dsn: import.meta.env.PUBLIC_SENTRY_DSN,
        integrations: [
          Sentry.extraErrorDataIntegration({ captureErrorCause: true }),
        ],
      });
    }

    app.use(plugin).mount(el);
  },
});
